import { z } from "zod";

export const CreateRouterRequestSchema = z.object({
  routerName: z.string().nullable().optional(),
  ipAddress: z.string().nullable().optional(),
});

export type CreateRouterRequest = z.infer<typeof CreateRouterRequestSchema>;

export const RouterEntitySchema = z.object({
  id: z.number(),
  routerName: z.string().nullable().optional(),
  companyId: z.number(),
  apiKey: z.string(),
  ipAddress: z.string().nullable().optional(),
  lastViewedAt: z.string().nullable().optional(),
});

export type RouterEntity = z.infer<typeof RouterEntitySchema>;

export const UpdateRouterRequestSchema = z.object({
  apiKey: z.string(),
  routerName: z.string().nullable().optional(),
  ipAddress: z.string().nullable().optional(),
});
export type UpdateRouterRequest = z.infer<typeof UpdateRouterRequestSchema>;

export const RouterInfoResponseSchema = z.object({
  id: z.number().nullable().optional(),
  routerName: z.string().nullable().optional(),
  companyId: z.number(),
  apiKey: z.string(),
  ipAddress: z.string().nullable().optional(),
});

export type RouterInfoResponse = z.infer<typeof RouterInfoResponseSchema>;
